// Routing for the dashboard "Build" / AI-chat action.
//
// The Studio (/studio) is the single builder for every site — the legacy /builder
// (PlanModePage HTML chat) and /builder/design (old block editor) are retired. The
// dashboard chat routes here with the typed prompt, and the Studio's BlocksChat
// auto-runs it, so the dashboard box behaves exactly like the Studio chat.

export function chooseBuildRoute(_isEmpty: boolean | undefined, prompt: string): string {
  // `_isEmpty` no longer affects routing (kept for the caller's call signature).
  return `/studio?prompt=${encodeURIComponent(prompt)}`;
}
